import {
  SessionAttendanceFileFragment,
  SessionFileFragment,
  TrainingClassFileFragment,
  TrainingFileFragment,
  TrainingMembershipFileFragment,
} from 'generated/resources/graphql'

import type { File } from 'modules/trainings/components/Files/FileViewer'

export enum FileType {
  sessionAttendanceFile = 'SessionAttendanceFile',
  sessionFile = 'SessionFile',
  trainingFile = 'TrainingFile',
  trainingMembershipFile = 'TrainingMembershipFile',
  classFile = 'ClassFile',
}

type BuildFileListParams = {
  fileNavigation?: (fileId: string) => string | undefined
  attendanceFiles?: SessionAttendanceFileFragment[]
  trainingFiles?: TrainingFileFragment[]
  sessionFiles?: SessionFileFragment[]
  membershipFiles?: TrainingMembershipFileFragment[]
  classFiles?: TrainingClassFileFragment[]
}

export const useTrainingsMixedFiles = () => {
  const buildFileUrl = (fileType: FileType, fileId: number) => {
    return fileType.concat(`-${fileId}`)
  }

  const buildFilesList = ({
    fileNavigation,
    attendanceFiles,
    trainingFiles,
    sessionFiles,
    membershipFiles,
    classFiles,
  }: BuildFileListParams): File[] => {
    const allFiles: File[] = []
    attendanceFiles &&
      allFiles.push(
        ...attendanceFiles.map((attendanceFile) => {
          const url = buildFileUrl(FileType.sessionAttendanceFile, Number(attendanceFile.id))
          return {
            id: attendanceFile.id,
            contentType: attendanceFile.contentType || '',
            filename: attendanceFile.filename,
            url: attendanceFile.url,
            navigation: fileNavigation ? fileNavigation(url) : '',
            fileUrl: url,
            type: 'trainingClass' as const,
          }
        })
      )

    trainingFiles &&
      allFiles.push(
        ...trainingFiles.map((file) => {
          const url = buildFileUrl(FileType.trainingFile, Number(file.id))
          return {
            id: file.id,
            contentType: file.contentType || '',
            filename: file.title || file.filename,
            url: file.url,
            navigation: fileNavigation ? fileNavigation(url) : '',
            fileUrl: url,
            type: 'training' as const,
          }
        })
      )

    classFiles &&
      allFiles.push(
        ...classFiles.map((file) => {
          const url = buildFileUrl(FileType.classFile, Number(file.id))
          return {
            id: file.id,
            contentType: file.contentType || '',
            filename: file.title || file.filename,
            url: file.url,
            navigation: fileNavigation ? fileNavigation(url) : '',
            fileUrl: url,
            type: 'trainingClass' as const,
          }
        })
      )

    sessionFiles &&
      allFiles.push(
        ...sessionFiles.map((file) => {
          const url = buildFileUrl(FileType.sessionFile, Number(file.id))
          return {
            id: file.id,
            contentType: file.contentType || '',
            filename: file.title || file.filename,
            url: file.url,
            navigation: fileNavigation ? fileNavigation(url) : '',
            fileUrl: url,
            type: 'trainingClass' as const,
          }
        })
      )

    membershipFiles &&
      allFiles.push(
        ...membershipFiles.map((file) => {
          const url = buildFileUrl(FileType.trainingMembershipFile, Number(file.id))
          return {
            id: file.id,
            contentType: file.contentType || '',
            filename: file.filename,
            url: file.url,
            navigation: fileNavigation ? fileNavigation(url) : '',
            fileUrl: url,
            type: 'membership' as const,
          }
        })
      )

    return allFiles
  }

  return {
    buildFilesList,
  }
}
